"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = exports.GamePoints = exports.Failure = exports.Chat = exports.Avatar = exports.usePlayers = exports.usePlayerId = exports.usePlayer = exports.usePlay = exports.useOptions = exports.useNumberOfPlayers = exports.useNow = exports.useGiveUp = exports.useGame = exports.useAnimations = exports.useAnimation = exports.useActions = exports.GameProvider = exports.PLATFORM_URI = void 0;
exports.PLATFORM_URI = (_a = process.env.REACT_APP_PLATFORM_URI) !== null && _a !== void 0 ? _a : 'https://game-park.com';
var GameProvider_1 = require("./GameProvider");
Object.defineProperty(exports, "GameProvider", { enumerable: true, get: function () { return __importDefault(GameProvider_1).default; } });
var useActions_1 = require("./Hooks/useActions");
Object.defineProperty(exports, "useActions", { enumerable: true, get: function () { return __importDefault(useActions_1).default; } });
var useAnimation_1 = require("./Hooks/useAnimation");
Object.defineProperty(exports, "useAnimation", { enumerable: true, get: function () { return __importDefault(useAnimation_1).default; } });
var useAnimations_1 = require("./Hooks/useAnimations");
Object.defineProperty(exports, "useAnimations", { enumerable: true, get: function () { return __importDefault(useAnimations_1).default; } });
var useGame_1 = require("./Hooks/useGame");
Object.defineProperty(exports, "useGame", { enumerable: true, get: function () { return __importDefault(useGame_1).default; } });
var useGiveUp_1 = require("./GiveUp/useGiveUp");
Object.defineProperty(exports, "useGiveUp", { enumerable: true, get: function () { return __importDefault(useGiveUp_1).default; } });
var useNow_1 = require("./Hooks/useNow");
Object.defineProperty(exports, "useNow", { enumerable: true, get: function () { return __importDefault(useNow_1).default; } });
var useNumberOfPlayers_1 = require("./Hooks/useNumberOfPlayers");
Object.defineProperty(exports, "useNumberOfPlayers", { enumerable: true, get: function () { return __importDefault(useNumberOfPlayers_1).default; } });
var useOptions_1 = require("./Hooks/useOptions");
Object.defineProperty(exports, "useOptions", { enumerable: true, get: function () { return __importDefault(useOptions_1).default; } });
var usePlay_1 = require("./Hooks/usePlay");
Object.defineProperty(exports, "usePlay", { enumerable: true, get: function () { return __importDefault(usePlay_1).default; } });
var usePlayer_1 = require("./Hooks/usePlayer");
Object.defineProperty(exports, "usePlayer", { enumerable: true, get: function () { return __importDefault(usePlayer_1).default; } });
var usePlayerId_1 = require("./Hooks/usePlayerId");
Object.defineProperty(exports, "usePlayerId", { enumerable: true, get: function () { return __importDefault(usePlayerId_1).default; } });
var usePlayers_1 = require("./Hooks/usePlayers");
Object.defineProperty(exports, "usePlayers", { enumerable: true, get: function () { return __importDefault(usePlayers_1).default; } });
__exportStar(require("./translation/TranslationSetup"), exports);
var Avatar_1 = require("./Avatar");
Object.defineProperty(exports, "Avatar", { enumerable: true, get: function () { return __importDefault(Avatar_1).default; } });
__exportStar(require("./Avatar"), exports);
var Chat_1 = require("./Chat");
Object.defineProperty(exports, "Chat", { enumerable: true, get: function () { return __importDefault(Chat_1).default; } });
__exportStar(require("./EjectPlayer"), exports);
var Failure_1 = require("./Failure");
Object.defineProperty(exports, "Failure", { enumerable: true, get: function () { return __importDefault(Failure_1).default; } });
__exportStar(require("./Failure"), exports);
__exportStar(require("./Fullscreen"), exports);
var GamePoints_1 = require("./GamePoints");
Object.defineProperty(exports, "GamePoints", { enumerable: true, get: function () { return __importDefault(GamePoints_1).default; } });
__exportStar(require("./GamePoints"), exports);
var Menu_1 = require("./Menu");
Object.defineProperty(exports, "Menu", { enumerable: true, get: function () { return __importDefault(Menu_1).default; } });
__exportStar(require("./Menu"), exports);
__exportStar(require("./PlayerTime"), exports);
__exportStar(require("./Sound"), exports);
__exportStar(require("./Theme"), exports);
__exportStar(require("./Tutorial"), exports);
__exportStar(require("./Undo"), exports);
